/**
 * Consentement « blessures » (RGPD art. 9 — données de santé), lot 3.
 *
 * Le même texte est présenté au diagnostic et dans l'éditeur « Mon programme ›
 * Blessures ». La version part en base avec l'accord
 * (`wizard_submissions.injury_consent_version`) : elle désigne le texte EXACT accepté.
 * Tout changement de ces deux textes = nouvelle version, l'ancien texte étant archivé
 * dans l'audit (docs/audits/AUDIT_ONBOARDING.md).
 */
export const INJURY_CONSENT_VERSION = "blessures-v1"

/** Phrase courte, à côté de la case. */
export const INJURY_CONSENT_LABEL =
  "J'accepte que Zeyone enregistre mes blessures, des données de santé, pour adapter mon programme."

/** Suite du texte, derrière « Détails » (suivie du lien vers la politique de confidentialité). */
export const INJURY_CONSENT_DETAILS =
  "Tu peux retirer ton accord à tout moment depuis Mon programme › Blessures : ces informations sont alors supprimées. Elles sont conservées tant que ton compte existe, et supprimées avec lui."
